import UserGroupIcon from '@heroicons/react/outline/esm/UserGroupIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { SpaceMemberListBlock as Component } from './Block.js'
import { SpaceMemberListProps } from './types.js'

/**
 * @deprecated use RegisteredMembersBlock instead
 */
export const RegisteredSpaceMemberListBlock = (
  intl: I18nShape,
): RegisteredBlock<SpaceMemberListProps> => {
  const { $t } = intl

  return {
    recommendedName: 'WhySpaceMemberList',
    Component,
    config: {
      type: BlockType.Block,
      displayName: $t({
        id: 'Blocks.SpaceMemberList.DisplayName',
        defaultMessage: '{SPACE_CC} Member List',
      }),
      deprecated: true,
      Icon: <UserGroupIcon />,
    },
  }
}
